import React from 'react'

import {createSvgIcon} from './utils'

export default createSvgIcon(
  <path
    clipRule="evenodd"
    d="M3 12.5a.5.5 0 0 0 .5.5h17a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-17a.5.5 0 0 0-.5.5v1Z"
    fillRule="evenodd"
  />,
  'Minus',
)
